/**
 * Políticas portal desde ticket plataforma + overrides URL.
 * Contrato: docs/CONTRATO-VIEWER-TICKETS.md, docs/CONTRATO-PLATAFORMA-PORTAL-PACIENTE.md
 */

export const PWA_INSTALL_QUERY_KEY = 'pwaInstall'
export const OFFLINE_CACHE_QUERY_KEY = 'offlineCache'

/**
 * @param {unknown} raw
 * @param {boolean} [defaultValue=true]
 * @returns {boolean}
 */
export function parseBooleanPolicyParam(raw, defaultValue = true) {
  if (raw == null || raw === '') return defaultValue
  const v = String(raw).trim().toLowerCase()
  if (v === '0' || v === 'false' || v === 'no' || v === 'off') return false
  if (v === '1' || v === 'true' || v === 'yes' || v === 'on') return true
  return defaultValue
}

/**
 * @param {object|null|undefined} ticket normalizeTicketResponse o raw API
 * @returns {boolean}
 */
export function pwaInstallFromTicket(ticket) {
  if (!ticket || typeof ticket !== 'object') return true
  if (ticket.pwaInstall != null) {
    return parseBooleanPolicyParam(ticket.pwaInstall, true)
  }
  if (ticket.pwa_install != null) {
    return parseBooleanPolicyParam(ticket.pwa_install, true)
  }
  const raw = ticket.raw
  if (raw && typeof raw === 'object') {
    if (raw.pwa_install != null) {
      return parseBooleanPolicyParam(raw.pwa_install, true)
    }
    if (raw.pwaInstall != null) {
      return parseBooleanPolicyParam(raw.pwaInstall, true)
    }
  }
  return true
}

/**
 * @param {object|null|undefined} ticket
 * @returns {boolean}
 */
export function offlineCacheFromTicket(ticket) {
  if (!ticket || typeof ticket !== 'object') return true
  if (ticket.offlineCache != null) {
    return parseBooleanPolicyParam(ticket.offlineCache, true)
  }
  if (ticket.offline_cache != null) {
    return parseBooleanPolicyParam(ticket.offline_cache, true)
  }
  const raw = ticket.raw
  if (raw && typeof raw === 'object') {
    if (raw.offline_cache != null) {
      return parseBooleanPolicyParam(raw.offline_cache, true)
    }
    if (raw.offlineCache != null) {
      return parseBooleanPolicyParam(raw.offlineCache, true)
    }
  }
  return true
}

/**
 * @param {URLSearchParams|null|undefined} params
 * @returns {boolean|null} null si no hay override en URL
 */
export function pwaInstallFromSearchParams(params) {
  if (!params || typeof params.get !== 'function') return null
  const raw = params.get(PWA_INSTALL_QUERY_KEY)
  if (raw == null || String(raw).trim() === '') return null
  return parseBooleanPolicyParam(raw, true)
}

/**
 * @param {URLSearchParams|null|undefined} params
 * @returns {boolean|null}
 */
export function offlineCacheFromSearchParams(params) {
  if (!params || typeof params.get !== 'function') return null
  const raw = params.get(OFFLINE_CACHE_QUERY_KEY)
  if (raw == null || String(raw).trim() === '') return null
  return parseBooleanPolicyParam(raw, true)
}

/**
 * @param {{
 *   ticket?: object|null,
 *   searchParams?: URLSearchParams|null,
 * }} [opts]
 * @returns {{ pwaInstall: boolean, offlineCache: boolean }}
 */
export function resolveViewerSessionPolicy(opts = {}) {
  const ticket = opts.ticket || null
  const params = opts.searchParams || null
  const urlPwa = pwaInstallFromSearchParams(params)
  const urlCache = offlineCacheFromSearchParams(params)
  return {
    pwaInstall:
      urlPwa != null ? urlPwa : pwaInstallFromTicket(ticket),
    offlineCache:
      urlCache != null ? urlCache : offlineCacheFromTicket(ticket),
  }
}
